import moment from "moment";
import {Svg} from "assets";

export const EscortAppPatientEnum = {
    OPEN: 'OPEN',
    ASSIGNED: 'ASSIGNED',
    ARRIVED: 'ARRIVED',
    EN_ROUT: 'EN_ROUT',
    COMPLETED: 'COMPLETED',
    NO_SHOW: 'NO_SHOW',
    CANCELLED: 'CANCELLED',
}

export const EscortAppPatientStatuses = {
    OPEN: 'Open',
    ASSIGNED: 'Assigned',
    COMPLETED: 'Completed',
    EN_ROUT: 'Enroute',
    ARRIVED: 'Arrived',
    NO_SHOW: 'No Show',
    CANCELLED: 'Canceled',
}

export const EscortAppPatientList = [
    {
        id: EscortAppPatientEnum.OPEN,
        name: EscortAppPatientStatuses.OPEN,
        Icon: Svg.OpenSvg,
    },

    {
        id: EscortAppPatientEnum.ASSIGNED,
        name: EscortAppPatientStatuses.ASSIGNED,
        Icon: Svg.AssignedSvg
    },

    {
        id: EscortAppPatientEnum.COMPLETED,
        name: EscortAppPatientStatuses.COMPLETED,
        Icon: Svg.CompletedSvg
    },

    {
        id: EscortAppPatientEnum.EN_ROUT,
        name: EscortAppPatientStatuses.EN_ROUT,
        Icon: Svg.EnrouteSvg
    },

    {
        id: EscortAppPatientEnum.ARRIVED,
        name: EscortAppPatientStatuses.ARRIVED,
        Icon: Svg.ArrivedSvg
    },

    {
        id: EscortAppPatientEnum.NO_SHOW,
        name: EscortAppPatientStatuses.NO_SHOW,
        Icon: Svg.ArrivedSvg
    },

    {
        id: EscortAppPatientEnum.CANCELLED,
        name: EscortAppPatientStatuses.CANCELLED,
        Icon: Svg.CanceledSvg
    },
]

export const TripTypesEnum = {
    APPOINTMENT: 'APPOINTMENT',
    MED_DROP: 'MED_DROP',
    BUS_ROUTE: 'BUS_ROUTE',
}

export const LegTypesEnum = {
    ESCORT_PICKUP: 'ESCORT_PICKUP',
    APPOINTMENT: 'APPOINTMENT',
    RETURN: 'RETURN',
    ESCORT_DROPOFF: 'ESCORT_DROPOFF',
    MED_DROP: 'MED_DROP',
    MED_DROP_RETURN: 'MED_DROP_RETURN',
    BUS_ROUTE: 'BUS_ROUTE',
    BUS_ROUTE_RETURN: 'BUS_ROUTE_RETURN',
}


export const RateTypesEnum = {
    WC: "WC",
    GURNEY: "GURNEY",
    WALKER: "WALKER",
};

export const RateTypes = {
    WC: "W/C",
    GURNEY: "Gurney",
    WALKER: "Ambulatory",
};

export const RateTypesForTable = {
    WC: "W",
    GURNEY: "GRN",
    WALKER: "A",
};

export const RateTypesList = [
    {
        id: RateTypesEnum["WC"],
        name: RateTypes.WC,
    },

    {
        id: RateTypesEnum["GURNEY"],
        name: RateTypes.GURNEY,
    },

    {
        id: RateTypesEnum["WALKER"],
        name: RateTypes.WALKER,
    },
];

export const SexTypesEnum = {
    MALE: "MALE",
    FEMALE: "FEMALE",
    OTHER: "OTHER",
};

export const SexTypes = {
    MALE: "Male",
    FEMALE: "Female",
    OTHER: "Other",
};

export const SexTypesList = [
    {
        id: SexTypesEnum.MALE,
        name: SexTypes.MALE,
    },

    {
        id: SexTypesEnum.FEMALE,
        name: SexTypes.FEMALE,
    },

    {
        id: SexTypesEnum.OTHER,
        name: SexTypes.OTHER,
    },
];

export const ImportedCSVTypesLegsEnum = {
    NORWALK: 'NORWALK',
    SOUTH_LA: 'SOUTH_LA',
};

export const ImportedCSVTypesLegs = {
    NORWALK: 'Norwalk',
    SOUTH_LA: 'South LA',
};

export const ImportedCSVTypesList = [
    {
        id: ImportedCSVTypesLegsEnum.NORWALK,
        name: ImportedCSVTypesLegs.NORWALK,
    },

    {
        id: ImportedCSVTypesLegsEnum.SOUTH_LA,
        name: ImportedCSVTypesLegs.SOUTH_LA,
    },
];


export const howMuchIsLeft = (date) => {
    if (!date) return '';

    if (date) {
        const targetTime = moment(date);
        const now = moment();
        const diffMinutes = targetTime.diff(now, "minutes");

        if (diffMinutes < 15) {
            return 15;
        } else if (diffMinutes >= 15 && diffMinutes <= 30) {
            return 30;
        } else {
            return true;
        }
    }
};

export const currentLegTypeData = {
    [LegTypesEnum.APPOINTMENT]: {
        svg: <Svg.Hospital2Svg/>,
        textTooltip: 'Appointment',
    },
    [LegTypesEnum.RETURN]: {
        svg: <Svg.House2Svg/>,
        textTooltip: 'Patient return',
    },
    [LegTypesEnum.ESCORT_PICKUP]: {
        svg: <Svg.EscortPickup2Svg/>,
        textTooltip: 'Escort',
    },
    [LegTypesEnum.ESCORT_DROPOFF]: {
        svg: <Svg.EscortDropOf2Svg/>,
        textTooltip: 'Escort',
    },
    [LegTypesEnum.MED_DROP]: {
        svg: <Svg.MedicationDrop2Svg/>,
        textTooltip: 'Medication Drop',
    },
    [LegTypesEnum.MED_DROP_RETURN]: {
        svg: <Svg.MedicationDropReturn2Svg/>,
        textTooltip: 'Medication Run',
    },
    [LegTypesEnum.BUS_ROUTE]: {
        svg: <Svg.BusRoute2Svg/>,
        textTooltip: 'Bus Route',
    },

    [LegTypesEnum.BUS_ROUTE_RETURN]: {
        svg: <Svg.BusRouteReturn2Svg/>,
        textTooltip: 'Bus Route Return',
    },
}

 export const currentLegStatusData = {
    [EscortAppPatientEnum.OPEN]: {
        backgroundColor: '#F3F4F6',
        color:'#374151',
    },
    [EscortAppPatientEnum.ASSIGNED]: {
        backgroundColor: '#EEF2FF',
        color:'#4F46E5',
    },
    [EscortAppPatientEnum.ARRIVED]: {
        backgroundColor: 'rgba(102, 159, 249, 0.18)',
        color:'#4F46E5',
    },
    [EscortAppPatientEnum.EN_ROUT]: {
        backgroundColor: '#FFFBEB',
        color:'#D97706',
    },
    [EscortAppPatientEnum.COMPLETED]: {
        backgroundColor: '#ECFDF5',
        color:'#059669',
    },
    [EscortAppPatientEnum.CANCELLED]: {
        backgroundColor: '#FEF2F2',
        color:'#DC2626',
    },
}

// export const howMuchIsLeft = (date) => {
//     if (date) {
//         const targetTime = moment(date);
//         const now = moment();
//         const diffMinutes = targetTime.diff(now, "minutes");
//
//
//         if (diffMinutes <= 15 && diffMinutes > 0) {
//             return 15
//         }
//         // else if (diffMinutes <= 30 && diffMinutes > 15) {
//         //     return 30
//         // }
//         else if (diffMinutes <= 0) {
//             return 0
//         } else {
//             return true
//         }
//     }
// }